import { Pipe, PipeTransform } from '@angular/core';
import { IQuickUrl } from 'src/app/state';

@Pipe({
  name: 'roleLinks',
  standalone: false,
})
export class RoleLinksPipe implements PipeTransform {
  public transform(value: IQuickUrl[], currentRole: string): IQuickUrl[] {
    if (currentRole === 'Admin') {
      return value;
    }

    return value.filter((e) => {
      return e.accessedBy.includes(currentRole);
    });
  }
}
